import styled from "styled-components";

import { CategoriesStyledProps as Props } from "./Categories.types";
import CONSTANTS from "config/constants";

const { tablet, mobile, desktop, wide } = CONSTANTS.BREAKPOINTS;
const { WITH_VERTICAL_CATEGORIES } = CONSTANTS.FEATURE_FLAGS;

const CategoriesStyled = styled.div<Props>`
  min-width: var(--sizes-page-minWidth);
  max-width: var(--sizes-page-maxWidth);
  min-height: var(--sizes-page-minHeight);
  padding-top: ${props =>
    !props.withBottomResponsiveButtons
      ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
      : props.withBottomSearch
      ? "var(--sizes-navbar-height-mobile)"
      : "var(--sizes-navbar-height-mobile-without-search)"};
  background: var(--palette-gray-s0-l97-a10);
  display: grid;
  grid-template-columns: var(--sizes-page-columns);
  grid-template-rows: max-content 1fr max-content;

  @media (min-width: ${tablet}px) {
    padding-top: ${props =>
      !props.withBottomResponsiveButtons
        ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
        : props.withBottomSearch
        ? "var(--sizes-navbar-height-mobile)"
        : "var(--sizes-navbar-height-mobile-without-search)"};
  }

  @media (min-width: ${desktop}px) {
    padding-top: calc(var(--sizes-navbar-height) - env(safe-area-inset-top));
  }

  .Categories {
    &__header {
      grid-column: 1 / -1;
    }

    &__tabs-mobile {
      width: 100%;
      padding: 1.6rem;
      padding-bottom: 0;

      @media (max-width: ${tablet}px) {
        display: flex;
      }
    }

    &__hide-scroll {
      overflow: hidden;

      &:hover {
        overflow-x: auto;
        scrollbar-color: var(--palette-gray-s0-l47) transparent;
      }
    }

    &__tabs-desktop {
      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__go-back {
      padding: 3.2rem 0;
      display: inline-flex;
    }

    &__title {
      color: var(--pallete-grey-3);
      padding-bottom: 2.4rem;
      font-size: 2.4rem;
    }

    &__recent-category {
      padding-top: 6.4rem;

      @media (max-width: ${tablet}px) {
        padding-top: 3.2rem;
      }
    }

    &__categoriesContainer {
      padding-top: 4rem;
      width: 100%;
      height: fit-content;
      grid-column: fullBleed;
      background-color: var(--palette-white);
      position: fixed;
      top: ${props =>
        !props.withBottomResponsiveButtons
          ? "var(--sizes-navbar-height-mobile-without-bottom-buttons)"
          : props.withBottomSearch
          ? "var(--sizes-navbar-height-mobile)"
          : "var(--sizes-navbar-height-mobile-without-search)"};
      z-index: 3;

      @media (min-width: ${desktop}px) {
        top: calc(var(--sizes-navbar-height));
        width: var(--sizes-page-maxWidth);
        display: grid;
        grid-template-columns: var(--sizes-page-columns);
        -webkit-align-items: center;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        grid-template-areas: ". content .";
        background-color: var(--palette-black-s25-l2);
      }

      @media (min-width: ${tablet + 1}px) {
        display: ${WITH_VERTICAL_CATEGORIES ? "none" : "flex"};
      }
    }

    &__categoriesMenu {
      grid-column: fullBleed;

      @media (max-width: ${tablet}px) {
        display: none;
      }
    }

    &__category__list {
      position: sticky;
      top: calc(var(--sizes-navbar-height) + 4.8rem);
      min-width: 23.2rem;
      height: min-content;
      margin: 0px 3.2rem 0px 0px;
      width: 100%;
      max-width: 23.2rem;
      border-radius: 2.4rem;
      background-color: var(--palette-white);
      padding: 0.4rem 1.6rem;

      @media (max-width: ${desktop}px) {
        top: calc(var(--sizes-navbar-height) + 8.4rem);
      }

      @media (max-width: ${tablet + 1}px) {
        display: none;
      }
    }

    &__scrollGalleryContainer {
      width: 100%;
    }

    &__backButtonContainer {
      padding-top: 2.4rem;
      background: var(--palette-white, white);
    }

    &__backButton {
      display: flex;
      align-items: center;
      padding-left: 0;
      line-height: 2.4rem;

      svg {
        margin-right: 1.2rem;

        > path {
          width: 100%;
          fill: var(--palette-black, black);
        }
      }
    }

    &__breadcrumbContainer,
    &__categoryGalleryContainer {
      background: var(--palette-white, white);
    }

    &__categories {
      display: flex;
      flex-direction: column;
      width: 100%;
    }

    &__category {
      display: flex;
      flex-direction: column;
      width: 100%;
      padding: 3.2rem 0.8rem;
      background-color: var(--palette-white);
      margin-top: 4.4rem;
      border-radius: 2.4rem;

      @media (min-width: ${tablet + 1}px) {
        &:first-child {
          margin-top: 3.6rem;
        }
      }

      &__name {
        padding: 1.2rem;
        margin-bottom: 2.4rem;
        font-size: 2.4rem;
        color: var(--palette-black-s0-l20);
        font-weight: 700;
        background-color: var(--palette-secondary-s35-l95);
        border-radius: 1.2rem;
        font-family: inherit;

        @media (max-width: ${tablet}px) {
          padding: 0.8rem 1.2rem;
        }
      }

      &__products {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        column-gap: 3.2rem;
        row-gap: 4rem;
        width: 100%;

        @media (max-width: ${desktop}px) {
          grid-template-columns: repeat(3, 1fr);
          column-gap: 1.6rem;
        }

        @media (max-width: ${tablet}px) {
          grid-template-columns: repeat(2, minmax(4rem, 1fr));
        }

        @media (max-width: ${mobile}px) {
          grid-template-columns: repeat(1, 1fr);
        }
      }

      &__product {
        width: 100%;
        transition: all 0.5 ease;
        padding: 1.6rem;

        & > div {
          width: 100%;
          height: min-content;
        }

        .Image__img {
          width: 100%;
          object-fit: cover;
          text-align: center;
          height: 28rem;

          @media (max-width: ${wide - 100}px) {
            height: 18rem;
          }

          @media (max-width: ${tablet}px) {
            height: 28rem;
          }

          @media (max-width: ${tablet - 100}px) {
            height: 24rem;
          }

          @media (max-width: ${tablet - 250}px) {
            height: 16rem;
          }

          @media (max-width: ${mobile}px) {
            height: 24rem;
          }
        }
      }
    }

    &__categoryGalleryContainer {
      .Image__img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__scroll {
      &--desktop {
        @media (max-width: ${tablet}px) {
          display: none;
        }
      }

      &--mobile {
        @media (min-width: ${tablet + 1}px) {
          display: none;
        }
      }
    }

    &__product-grid-placeholder {
      padding-top: 13.6rem;
      padding-bottom: 8rem;

      @media (max-width: ${tablet}px) {
        padding: 10rem 1.2rem;
        margin: 0;
        grid-template-columns: repeat(3, 1fr);
        gap: 0;
        row-gap: 6.5rem;
      }

      @media (max-width: ${mobile - 1}px) {
        row-gap: 8.6rem;
      }

      .ProductCardPlaceholder {
        @media (max-width: ${tablet}px) {
          width: 18rem;
          padding: 0;
        }

        @media (max-width: ${mobile - 1}px) {
          width: 12.4rem;
          padding: 0;
        }

        &__image {
          height: 20rem;

          @media (max-width: ${tablet}px) {
            width: 10rem;
            height: 10rem;
          }

          @media (max-width: ${mobile - 1}px) {
            width: 100%;
            height: 12.4rem;
          }
        }

        &__add {
          @media (max-width: ${tablet}px) {
            width: 10rem;
          }
        }
      }
    }

    &__main {
      flex: 1;
      grid-column: fullBleed;

      @media (min-width: ${tablet + 1}px) {
        grid-column: content-start / content-end;
        margin-top: 5.2rem;
        margin-bottom: 8.8rem;
      }

      &__content {
        @media (min-width: ${tablet + 1}px) {
          display: flex;
        }
      }

      &__header {
        @media (max-width: ${tablet}px) {
          display: none;
        }
      }

      .ProductGallery {
        margin: 0.8rem 0 0;
        padding: 4.8rem 0 2rem;
        background: var(--palette-white, white);

        .Gallery__aside {
          padding-left: 2.4rem;
        }
      }

      .CategoryGallery,
      .ProductsSlider {
        padding: 6.4rem 0 2rem;
        background: white;
      }

      .CategoryGallery {
        margin: 0;
      }

      .ProductsSlider {
        margin: 0.8rem 0 0;

        &__title {
          padding: 0 0 2rem;
        }
      }
    }

    &__footer {
      grid-column: 1 / -1;

      @media (max-width: ${tablet}px) {
        padding-top: 3.2rem;
      }
    }

    &__scrollToTopButton {
      bottom: 4rem;
      right: 1.6rem;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      @media (max-width: ${tablet}px) {
        bottom: ${props => (props.talkShop ? "4rem" : "12rem")};
      }

      > svg {
        transform: rotate(90deg);
      }
    }
  }

  .ProductGridPlaceholder {
    @media (max-width: ${tablet}px) {
      margin: 0;
      width: auto;
    }
  }
`;

export default CategoriesStyled;
